import { ajax } from "@/assets/js/ajax";
export function getAccount(data) {
  //账户列表
  return ajax({
    url: "user/index",
    type: "get",
    data: data,
  });
}

export function accountInfo(data) {
  //账户详情
  return ajax({
    url: "user/info",
    type: "get",
    data: data,
  });
}

export function userGroup(data) {
  //账户身份权限
  return ajax({
    url: "user/group",
    type: "get",
  });
}

export function userEdit(data) {
  //账户修改
  return ajax({
    url: "user/edit",
    type: "post",
    data: data,
    contentType: "application/json",
  });
}

export function userAdd(data) {
  //账户添加
  return ajax({
    url: "user/add",
    type: "post",
    data: data,
  });
}

export function userCom(data) {
  //搜索公司
  return ajax({
    url: "user/title",
    type: "get",
    data: data,
  });
}

export function accList(data) {
  //原告权限列表
  return ajax({
    url: "accuserMenu/tree",
    type: "get",
    data: data,
  });
}
export function accUpdate(data) {
  //原告权限编辑
  return ajax({
    url: "accuserMenu/update",
    type: "put",
    data: data,
    contentType: "application/json",
  });
}

export function accDel(data) {
  //原告权限删除
  return ajax({
    url: "accuserMenu/delete",
    type: "delete",
    data: data,
    contentType: "application/json",
  });
}
export function accAcc(data) {
  //原告新增权限
  return ajax({
    url: "accuserMenu/save",
    data: data,
    contentType: "application/json",
  });
}

export function accUserList(data) {
  //所有用户检索 查找
  return ajax({
    url: "user/option",
    data: data,
    type: "get",
  });
}
export function causeStStepUser(data) {
  return ajax({
    url: "cause/setStepUser",
    data: data,
    //contentType: 'application/json'
  });
}

export function accuserRole(type, data) {
  return ajax({
    url: "/accuser.role/" + type,
    data: data,
    type: type == "index" || type == "info" ? "get" : "post",
    contentType: "application/json",
  });
}

export function addUserAccuserMenu(data) {
  return ajax({
    url: "/accuser.menu/addUserAccuserMenu",
    data: data,
    type: "post",
    contentType: "application/json",
  });
}
export function addUserAccuserMenuList(data) {
  return ajax({
    url: "/accuser.menu/addUserAccuserMenuList",
    data: data,
    type: "post",
    contentType: "application/json",
  });
}
export function changeAuditTime(data) {
  return ajax({
    url: "/user/changeAuditTime",
    data: data,
    type: "post",
    contentType: "application/json",
  });
}

export function userGrounp(type, data) {
  return ajax({
    url: "/userGroup/" + type,
    data: data,
    type: type == "index" || type == "delete" ? "get" : "post",
    contentType: "application/json",
  });
}

//账号登录记录
export function userLog(data) {
  return ajax({
    url: "user/user_log",
    data: data,
    type: "get",
  });
}

//最近一次登录信息
export function userLogLast(data) {
  return ajax({
    url: "user/user_log_last",
    data: data,
    type: "get",
  });
}
